import {Box, Heading, HStack, Icon, Show} from 'platform/foundation';

import type {ReactNode} from 'react';

import type {
  AdvertisementPreviewPlatform,
  GetAdvertisementPreviewApiResponse,
} from '@dms/api/sales';
import i18n from '@dms/i18n';

import type {RequiredTestIdProps} from 'shared/web';

import {ADVERTISEMENT_PREVIEW_SECTION_ICONS} from './ADVERTISEMENT_PREVIEW_SECTION_ICONS';
import {AdvertisementPreviewDescription} from './AdvertisementPreviewDescription';
import {AdvertisementPreviewLanguageSwitcher} from './AdvertisementPreviewLanguageSwitcher';
import {SectionCard, SectionCardContent, SectionCardHeader} from './PreviewSectionCard';

export function AdvertisementPreviewDescriptionCard(
  props: RequiredTestIdProps & {
    data: GetAdvertisementPreviewApiResponse;
    selectedPlatform?: AdvertisementPreviewPlatform;
    isDefaultLanguage: boolean;
    isTextFetching: boolean;
    languageOptions: Array<{value: string; label: ReactNode}>;
    activeLanguage: string;
    showLanguageTabs: boolean;
    onLanguageChange: (language: string) => void;
  }
) {
  const description =
    props.isDefaultLanguage && props.selectedPlatform
      ? props.selectedPlatform.description.value
      : props.data.description;
  return (
    <Box flexGrow={0} flexShrink={0} flexBasis="auto">
      <SectionCard data-testid={`${props['data-testid']}-description`}>
        <SectionCardHeader>
          <HStack spacing={2} align="center">
            <Icon
              value={ADVERTISEMENT_PREVIEW_SECTION_ICONS.description}
              size={5}
              color="general.accent"
              isNotFilled
            />
            <Heading size={4}>
              {i18n.t('entity.sourcing.vehiclePreview.labels.vehicleDescription')}
            </Heading>
          </HStack>
          <Show when={props.showLanguageTabs}>
            <AdvertisementPreviewLanguageSwitcher
              activeLanguage={props.activeLanguage}
              languageOptions={props.languageOptions}
              onLanguageChange={props.onLanguageChange}
              data-testid={props['data-testid']}
            />
          </Show>
        </SectionCardHeader>
        <SectionCardContent>
          <AdvertisementPreviewDescription
            value={description}
            format={
              props.isDefaultLanguage && props.selectedPlatform
                ? props.selectedPlatform.description.format
                : 'html'
            }
            isDefaultLanguage={props.isDefaultLanguage}
            isLoading={props.isTextFetching}
            data-testid={`${props['data-testid']}-description-skeleton`}
          />
        </SectionCardContent>
      </SectionCard>
    </Box>
  );
}
